import { Row, Col } from "react-bootstrap";
import { Component } from "react";
import React from "react";

import BackComponent from "../../shared/components/backComponent/back";
import "./projectsStyle.scss";
import DropdownComponent from "../../shared/components/dropdown/Dropdown";
import { projects } from "../../shared/constants/projects";
import { skills } from "../../shared/constants/skills";
import Project from "./project/Project";

class Projects extends Component {
  state = {
    dropdownSkills: [],
    selectedElement: null,
  };

  unshiftDefaultValue(arr) {
    arr.unshift({
      name: "all",
    });
    return arr;
  }

  componentDidMount() {
    let dropdownSkills = [...skills];
    dropdownSkills = this.unshiftDefaultValue(dropdownSkills);
    this.setState({
      dropdownSkills,
    });

    this.onSkillSelect(dropdownSkills[0]);
  }

  onSkillSelect(selectedElement) {
    this.setState({
      selectedElement,
    });
  }

  isProjectValidByDropdown(projectObj) {
    const { selectedElement } = this.state;
    if (!selectedElement || selectedElement.name === "all") return true;

    return (
      projectObj &&
      projectObj.skills.find((skillName) => skillName === selectedElement.name)
    );
  }

  getProjectSkillIcons(projectSkills) {
    return projectSkills.map(
      (skill) =>
        skills
          .filter((skillParent) => skillParent.name === skill)
          .map(({ name, icon, iconType }) => ({
            name,
            icon,
            iconType,
          }))[0]
    );
  }

  render() {
    const { dropdownSkills, selectedElement } = this.state;

    return (
      <div className="projects__wrapper">
        <Row>
          <Col xs={12} sm={12} md={12} lg={8}>
            <div className="projects__content">
              <div className="projects__header--wrapper">
                <div>
                  <BackComponent />
                </div>
                <div className="projects__header__dropdown">
                  <span className="projects__header__dropdown__label">
                    skills:
                  </span>
                  <DropdownComponent
                    options={dropdownSkills}
                    title={selectedElement && selectedElement.name}
                    optionsNameProp="name"
                    onSelectElement={(skill) => {
                      this.onSkillSelect(skill);
                    }}
                  />
                </div>
              </div>
              <div className="projects__elements--wrapper">
                {projects.map(
                  (project) =>
                    this.isProjectValidByDropdown(project) && (
                      <Project
                        title={project.name}
                        description={project.description}
                        githubLink={project.githubLink}
                        appLink={project.appLink}
                        dateProjectStarted={project.dateProjectStarted}
                        skillsImages={this.getProjectSkillIcons(project.skills)}
                      />
                    )
                )}
              </div>
            </div>
          </Col>
          <Col xs={0} sm={0} md={0} lg={0} xl={4}>
            <div className="projects__side-image--wrapper">
              <span className="projects__side-image__text">projects</span>
              <span className="projects__side-image__square projects__side-image__square--right"></span>
              <span className="projects__side-image__square projects__side-image__square--left"></span>
              <img
                alt="Side img"
                className="projects__side-image"
                src={require("../../public/images/output.png")}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Projects;
